module.exports = __webpack_public_path__ + "images/company/rank_medal/request_count_rank/3_7fe0e8a9ff80eb46b46e407b4891ce77.png";